import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import RegistrationTypeDrawer from "components/drawer/RegistrationTypeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";

// internal imports

const RegistrationTypeTable = ({
  registrationTypedata,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <MainDrawer>
        <RegistrationTypeDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {registrationTypedata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>
            <TableCell className="text-center text-xs">{data.name}</TableCell>
            {(hideEdit || hideDelete) && (
              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    title={data["Registration Type"]}
                    id={data.id}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideEdit={hideEdit}
                    // hideDelete={hideDelete}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default RegistrationTypeTable;
